module.exports = __webpack_public_path__ + "assets/img/food_processor.c12b7a92.png";